// extracted by mini-css-extract-plugin
module.exports = {"container":"PostList_container__31kYo","preview":"PostList_preview__mNuS6"};